import { z } from 'zod'

import { okamiHttpGateway } from '@/lib/axios'
import { CACHE_TIME } from '@/utils/helpers.ts'
import { useQuery } from '@tanstack/react-query'

const getUserDetailsSchema = z.object({
  isTelegramSubscriber: z.boolean(),
  trialQuoteLimit: z.number().nullable(),
  notionDatabaseId: z.string().nullable(),
  role: z.enum(['ADMIN', 'USER', 'SUBSCRIBED_USER']),
  id: z.string(),
  emailConfirmed: z.boolean(),
  avatarImageUrl: z.string().nullable(),
  name: z.string(),
  email: z.string().email(),
  finishedWorksCount: z.number().optional().default(0),
  readingWorksCount: z.number().optional().default(0),
})

export type GetUserDetailsType = z.infer<typeof getUserDetailsSchema>

export async function getUserDetails() {
  const { data } = await okamiHttpGateway.get<GetUserDetailsType>('/auth/user/me')

  return getUserDetailsSchema.parse(data)
}

export const getUserDetailsQueryKey = () => ['user-details'] as const

export const getUserDetailsQueryOptions = () => ({
  queryKey: getUserDetailsQueryKey(),
  queryFn: getUserDetails,
  staleTime: CACHE_TIME.ONE_HOUR,
  gcTime: CACHE_TIME.ONE_HOUR,
})

export function useUserDetails() {
  return useQuery(getUserDetailsQueryOptions())
}
